import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AnalyticsProvider } from '@mayo/react-analytics-tracker/legacy';

class AnalyticsWrapper extends Component {
  render() {
    const { children, employeeId, companyId, companyName, userName } = this.props;

    return (
      <AnalyticsProvider
        autoTrack
        trackingApiUrl="https://tst-apolloxe.mayohr.com/backend/tracking"
        production="FD"
        platform="test"
        employeeId={employeeId}
        companyId={companyId}
        companyName={companyName}
        userName={userName}
      >
        {children}
      </AnalyticsProvider>
    );
  }
}

AnalyticsWrapper.propTypes = {
  children: PropTypes.node,
  employeeId: PropTypes.string,
  companyId: PropTypes.string,
  companyName: PropTypes.string,
  userName: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    employeeId: state.app.user.employeeId,
    companyId: state.app.user.companyId,
    companyName: state.app.application.companyName,
    userName: state.app.user.userDisplayName,
  };
}

export default connect(mapStateToProps)(AnalyticsWrapper);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/components/AnalyticsWrapper/index.js
 **/